<template>
    <div class="sidebar-content">
        <b-form @submit.prevent="saveClient">
            <div class="form-section">
                <h6 class="section-title">Основная информация</h6>
                <div class="row">
                    <div class="col-md-6">
                        <b-form-group label="Название компании *" label-for="company_name">
                            <b-form-input
                                id="company_name"
                                v-model="form.company_name"
                                :state="validateState('company_name')"
                                required
                            />
                            <b-form-invalid-feedback>
                                Название компании обязательно
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group label="ИНН" label-for="inn">
                            <b-form-input
                                id="inn"
                                v-model="form.inn"
                                :state="validateState('inn')"
                                maxlength="12"
                            />
                            <b-form-invalid-feedback>
                                ИНН должен быть уникальным
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6">
                        <b-form-group label="Email" label-for="email">
                            <b-form-input
                                id="email"
                                v-model="form.email"
                                type="email"
                                :state="validateState('email')"
                            />
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group label="Сайт" label-for="website">
                            <b-form-input
                                id="website"
                                v-model="form.website"
                                :state="validateState('website')"
                            />
                        </b-form-group>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <b-form-group label="Сфера деятельности" label-for="industry">
                            <b-form-input
                                id="industry"
                                v-model="form.industry"
                            />
                        </b-form-group>
                    </div>
                </div>
            </div>

            <div class="form-section">
                <h6 class="section-title">Контакты</h6>
                <div class="row">
                    <div class="col-md-12">
                        <b-form-group label="Телефоны" label-for="phones">
                            <div v-for="(phone, index) in form.phones" :key="index" class="d-flex mb-2">
                                <b-form-input
                                    v-model="form.phones[index]"
                                    placeholder="+7 (999) 999-99-99"
                                />
                                <b-button
                                    variant="outline-danger"
                                    size="sm"
                                    @click="removePhone(index)"
                                    class="ml-2"
                                >
                                    <i class="bx bx-trash"></i>
                                </b-button>
                            </div>
                            <b-button
                                variant="outline-primary"
                                size="sm"
                                @click="addPhone"
                            >
                                <i class="bx bx-plus"></i> Добавить телефон
                            </b-button>
                        </b-form-group>
                    </div>
                </div>
            </div>

            <div class="form-section">
                <h6 class="section-title">Местоположение</h6>
                <div class="row">
                    <div class="col-md-6">
                        <b-form-group label="Регион" label-for="region_id">
                            <b-form-select
                                id="region_id"
                                v-model="form.region_id"
                                :options="regionOptions"
                                @change="onRegionChange"
                            />
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group label="Город" label-for="city_id">
                            <b-form-select
                                id="city_id"
                                v-model="form.city_id"
                                :options="cityOptions"
                                :disabled="!form.region_id"
                            />
                        </b-form-group>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <b-form-group label="Адрес" label-for="address">
                            <b-form-input
                                id="address"
                                v-model="form.address"
                            />
                        </b-form-group>
                    </div>
                </div>
            </div>

            <div class="form-section">
                <h6 class="section-title">Контактное лицо</h6>
                <div class="row">
                    <div class="col-md-6">
                        <b-form-group label="Контактное лицо" label-for="contact_person">
                            <b-form-input
                                id="contact_person"
                                v-model="form.contact_person"
                            />
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group label="Должность" label-for="position">
                            <b-form-input
                                id="position"
                                v-model="form.position"
                            />
                        </b-form-group>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <b-form-group label="Лицо, принимающее решения" label-for="decision_maker">
                            <b-form-input
                                id="decision_maker"
                                v-model="form.decision_maker"
                            />
                        </b-form-group>
                    </div>
                </div>
            </div>

            <div class="form-section">
                <h6 class="section-title">Бизнес информация</h6>
                <div class="row">
                    <div class="col-md-6">
                        <b-form-group label="Количество сотрудников" label-for="employees_count">
                            <b-form-input
                                id="employees_count"
                                v-model="form.employees_count"
                                type="number"
                                min="1"
                            />
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group label="Годовой оборот" label-for="annual_revenue">
                            <b-form-input
                                id="annual_revenue"
                                v-model="form.annual_revenue"
                                type="number"
                                min="0"
                                step="0.01"
                            />
                        </b-form-group>
                    </div>
                </div>
            </div>

            <div class="form-section">
                <h6 class="section-title">Статус и планирование</h6>
                <div class="row">
                    <div class="col-md-6">
                        <b-form-group label="Статус сотрудничества" label-for="cooperation_status">
                            <b-form-select
                                id="cooperation_status"
                                v-model="form.cooperation_status"
                                :options="statusOptions"
                            />
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group label="Следующий контакт" label-for="next_contact_at">
                            <b-form-input
                                id="next_contact_at"
                                v-model="form.next_contact_at"
                                type="date"
                            />
                        </b-form-group>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <b-form-group label="Источник данных" label-for="data_source">
                            <b-form-input
                                id="data_source"
                                v-model="form.data_source"
                            />
                        </b-form-group>
                    </div>
                </div>
            </div>

            <div class="form-section">
                <h6 class="section-title">Заметки</h6>
                <div class="row">
                    <div class="col-md-12">
                        <b-form-group label="Комментарий" label-for="comment">
                            <b-form-textarea
                                id="comment"
                                v-model="form.comment"
                                rows="3"
                            />
                        </b-form-group>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <b-form-group label="Заметки агента" label-for="notes">
                            <b-form-textarea
                                id="notes"
                                v-model="form.notes"
                                rows="3"
                            />
                        </b-form-group>
                    </div>
                </div>
            </div>

            <div class="form-actions-bottom">
                <b-button
                    variant="secondary"
                    @click="$emit('input', false)"
                    class="mr-2"
                >
                    Отмена
                </b-button>
                <b-button
                    variant="primary"
                    @click="saveClient"
                    :disabled="!isFormValid"
                >
                    {{ isEditing ? 'Сохранить' : 'Добавить' }}
                </b-button>
            </div>
        </b-form>
    </div>
</template>

<script>
export default {
    name: 'ColdClientModal',
    props: {
        value: {
            type: Boolean,
            default: false
        },
        client: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            form: {
                company_name: '',
                inn: '',
                email: '',
                website: '',
                phones: [''],
                industry: '',
                region_id: '',
                city_id: '',
                address: '',
                contact_person: '',
                position: '',
                employees_count: '',
                annual_revenue: '',
                decision_maker: '',
                cooperation_status: 'new',
                data_source: '',
                next_contact_at: '',
                comment: '',
                notes: ''
            },
            regionOptions: [
                { value: '', text: 'Выберите регион' }
            ],
            cityOptions: [
                { value: '', text: 'Выберите город' }
            ],
            statusOptions: [
                { value: 'new', text: 'Не обработан' },
                { value: 'contacted', text: 'Связались' },
                { value: 'interested', text: 'Заинтересован' },
                { value: 'not_interested', text: 'Не заинтересован' },
                { value: 'no_answer', text: 'Не дозвонились' }
            ],
            errors: {}
        }
    },
    computed: {
        isEditing() {
            return !!this.client
        },
        isFormValid() {
            return this.form.company_name
        }
    },
    watch: {
        value(newVal) {
            if (newVal) {
                this.loadRegions()
                if (this.client) {
                    this.fillForm()
                }
            }
        }
    },
    methods: {
        async loadRegions() {
            try {
                const response = await this.$api.regions.getRegions()
                if (response.success) {
                    this.regionOptions = [
                        { value: '', text: 'Выберите регион' },
                        ...response.data.map(region => ({
                            value: region.id,
                            text: region.name
                        }))
                    ]
                }
            } catch (error) {
                console.error('Ошибка загрузки регионов:', error)
            }
        },
        async loadCities(regionId) {
            if (!regionId) {
                this.cityOptions = [{ value: '', text: 'Выберите город' }]
                return
            }
            
            try {
                const response = await this.$api.regions.getCities(regionId)
                if (response.success) {
                    this.cityOptions = [
                        { value: '', text: 'Выберите город' },
                        ...response.data.map(city => ({
                            value: city.id,
                            text: city.name
                        }))
                    ]
                }
            } catch (error) {
                console.error('Ошибка загрузки городов:', error)
            }
        },
        onRegionChange() {
            this.form.city_id = ''
            this.loadCities(this.form.region_id)
        },
        addPhone() {
            this.form.phones.push('')
        },
        removePhone(index) {
            if (this.form.phones.length > 1) {
                this.form.phones.splice(index, 1)
            }
        },
        fillForm() {
            this.form = {
                company_name: this.client.company_name || '',
                inn: this.client.inn || '',
                email: this.client.email || '',
                website: this.client.website || '',
                phones: this.client.phones && this.client.phones.length ? [...this.client.phones] : [''],
                industry: this.client.industry || '',
                region_id: this.client.city?.region_id || '',
                city_id: this.client.city_id || '',
                address: this.client.address || '',
                contact_person: this.client.contact_person || '',
                position: this.client.position || '',
                employees_count: this.client.employees_count || '',
                annual_revenue: this.client.annual_revenue || '',
                decision_maker: this.client.decision_maker || '',
                cooperation_status: this.client.cooperation_status || 'new',
                data_source: this.client.data_source || '',
                next_contact_at: this.client.next_contact_at || '',
                comment: this.client.comment || '',
                notes: this.client.notes || ''
            }
            
            if (this.form.region_id) {
                this.loadCities(this.form.region_id)
            }
        },
        resetForm() {
            this.form = {
                company_name: '',
                inn: '',
                email: '',
                website: '',
                phones: [''],
                industry: '',
                region_id: '',
                city_id: '',
                address: '',
                contact_person: '',
                position: '',
                employees_count: '',
                annual_revenue: '',
                decision_maker: '',
                cooperation_status: 'new',
                data_source: '',
                next_contact_at: '',
                comment: '',
                notes: ''
            }
            this.errors = {}
        },
        validateState(field) {
            return this.errors[field] ? false : null
        },
        async saveClient() {
            try {
                const data = {
                    ...this.form,
                    phones: this.form.phones.filter(phone => phone.trim())
                }
                
                if (this.isEditing) {
                    await this.$api.coldClients.updateColdClient(this.client.id, data)
                } else {
                    await this.$api.coldClients.createColdClient(data)
                }
                
                this.$emit('saved')
                this.$bvToast.toast(
                    this.isEditing ? 'Клиент успешно обновлен' : 'Клиент успешно добавлен',
                    {
                        title: 'Успех',
                        variant: 'success'
                    }
                )
            } catch (error) {
                console.error('Ошибка сохранения клиента:', error)
                if (error.response?.data?.error) {
                    this.errors = error.response.data.error
                }
                this.$bvToast.toast('Ошибка при сохранении клиента', {
                    title: 'Ошибка',
                    variant: 'danger'
                })
            }
        }
    }
}
</script>

<style scoped>
.sidebar-content {
    padding: 1rem;
    height: 100%;
    overflow-y: auto;
}

.form-section {
    margin-bottom: 2rem;
    padding-bottom: 1rem;
    border-bottom: 1px solid #eee;
}

.form-section:last-child {
    border-bottom: none;
}

.section-title {
    color: #495057;
    font-weight: 600;
    margin-bottom: 1rem;
    padding-bottom: 0.5rem;
    border-bottom: 2px solid #0d6348;
}

.form-actions-bottom {
    position: absolute;
    width: 100%;
    padding: 20px 25px;
    left: 0;
    bottom: 0;
    background: #fff;
    border-top: 1px solid #eee;
    text-align: right;
}
</style>
